import {
    ChangeDetectionStrategy,
    Component,
    EventEmitter,
    Input,
    OnInit,
    Output,
} from '@angular/core';
import {
    UntypedFormControl,
    UntypedFormGroup,
    Validators,
} from '@angular/forms';
import { ActionsSubject } from '@ngrx/store';
import {
    TRANSLATION_CANCEL_BTN,
    TRANSLATION_DOC_CHECKLIST_DOC_CHECKLIST_GENERATE_TEMPLATE,
    TRANSLATION_GENERATE_BTN,
    WdxDestroyClass,
} from '@wdx/shared/utils';
import { BehaviorSubject, of } from 'rxjs';
import { DocumentsFacadeService } from '../shared/services';
import { GenerateDocumentTemplateItem } from './generate-document-template-modal.model';

@Component({
    selector: 'clmi-generate-document-template-modal',
    templateUrl: './generate-document-template-modal.component.html',
    styleUrls: ['./generate-document-template-modal.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false,
})
export class GenerateDocumentTemplateModalComponent
    extends WdxDestroyClass
    implements OnInit
{
    @Input() items: GenerateDocumentTemplateItem[];
    @Output() cancelled = new EventEmitter();
    @Output() submitted = new EventEmitter();

    documentTemplates$ = of(null);
    isGenerating$ = new BehaviorSubject<boolean>(null);

    documentGenerated = new EventEmitter();

    form: UntypedFormGroup;

    readonly TRANSLATION_DOC_CHECKLIST_DOC_CHECKLIST_GENERATE_TEMPLATE =
        TRANSLATION_DOC_CHECKLIST_DOC_CHECKLIST_GENERATE_TEMPLATE;
    readonly TRANSLATION_CANCEL_BTN = TRANSLATION_CANCEL_BTN;
    readonly TRANSLATION_GENERATE_BTN = TRANSLATION_GENERATE_BTN;

    constructor(
        private actionsSubject$: ActionsSubject,
        private documentsFacadeService: DocumentsFacadeService,
    ) {
        super();
    }

    ngOnInit(): void {
        this.form = new UntypedFormGroup({});

        this.items.forEach((item) => {
            this.form.addControl(
                item.documentRequirementId,
                new UntypedFormGroup({
                    documentTypeCode: new UntypedFormControl(
                        null,
                        Validators.required,
                    ),
                    documentTemplateId: new UntypedFormControl(
                        null,
                        Validators.required,
                    ),
                }),
            );
        });
    }

    onSubmit(): void {
        if (this.form.invalid) {
            this.form.markAllAsTouched();
            return;
        }

        this.isGenerating$.next(true);

        const payload = Object.entries(this.form.value).map(
            ([documentRequirementId, formValue]) => {
                return {
                    documentRequirementId,
                    documentTemplateId: (formValue as any).documentTemplateId,
                };
            },
        );

        this.documentsFacadeService.generateDocumentFromTemplate(payload);

        this.submitted.emit();
    }

    onCancel(): void {
        this.cancelled.emit();
    }
}
